import { SearchInput } from "@/components/flexkit/SearchInput";
import type { FC } from "react";

type ArchivedEnvironmentSearchInputProps = {
    searchValue?: string;
    disabled?: boolean;
    setSearchValue: (value: string) => void;
};

export const ArchivedEnvironmentSearchInput: FC<ArchivedEnvironmentSearchInputProps> = ({
    searchValue,
    disabled,
    setSearchValue,
}) => {
    return (
        <div className="flex w-full">
            <span className="sr-only">Search archived environments</span>
            <SearchInput
                wrapperClassName="w-full"
                className="max-w-none"
                placeholder={disabled ? "Nothing archived" : "Search archived environments"}
                value={searchValue || ""}
                onChange={(e) => setSearchValue(e.target.value.trimStart().replace(/\s+/g, " "))}
                onClear={() => setSearchValue("")}
                disabled={disabled}
            />
        </div>
    );
};
